import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BcPrivilegesFacade } from '@bayclubs/employee-auth';
import { filter } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { CampsSecurityService } from '../../../infrastructure/infrastructure.module';

@Component({
    selector: 'app-side-menu',
    templateUrl: './side-menu.component.html',
    styleUrls: ['./side-menu.component.scss'],
    standalone: false,
})
export class SideMenuComponent implements OnInit {
    public mainPageComponents: SideMenuLink[] = [];

    constructor(
        private router: Router,
        private privilegesFacade: BcPrivilegesFacade,
        private campsSecurity: CampsSecurityService
    ) {}

    ngOnInit() {
        this.init();
        this.privilegesFacade.privileges$.pipe(filter((privileges) => !!privileges)).subscribe(() => {
            this.init();
        });
    }

    public init() {
        this.mainPageComponents = [];

        this.mainPageComponents.push(<SideMenuLink>{
            name: 'Dashboard',
            testId: 'side-menu-dashboard',
            action: () => {
                this.goToDashboard();
            },
            icon: 'i-dashboard',
            isSelected: () => {
                return this.router.isActive('/', true);
            },
        });
        this.mainPageComponents.push(<SideMenuLink>{
            name: 'Purchase list',
            testId: 'side-menu-purchase-list',
            action: () => {
                this.goToEnrollment();
            },
            icon: 'i-purchase-list',
            isSelected: () => {
                return this.router.isActive('/purchases', false);
            },
        });
        this.mainPageComponents.push(<SideMenuLink>{
            name: 'Camps management',
            testId: 'side-menu-camps-management',
            action: () => {
                this.goToCampsDefinitions();
            },
            icon: 'i-camps-managment',
            isSelected: () => {
                return this.router.isActive('/camps', false);
            },
        });
        this.mainPageComponents.push(<SideMenuLink>{
            name: 'Roster',
            testId: 'side-menu-roster',
            action: () => {
                this.goToRoster();
            },
            icon: 'i-roster',
            isSelected: () => {
                return this.router.isActive('/roster', false);
            },
        });
        this.mainPageComponents.push(<SideMenuLink>{
            name: 'Coupons',
            testId: 'side-menu-coupons',
            action: () => {
                this.goToCoupons();
            },
            icon: 'i-coupon',
            isSelected: () => {
                return this.router.isActive('/coupons', false);
            },
        });

        this.campsSecurity.canViewReports().subscribe((canViewReport) => {
            if (canViewReport === false) {
                return;
            }
            this.mainPageComponents.push(<SideMenuLink>{
                name: 'Reports',
                testId: 'side-menu-reports',
                action: () => {
                    this.goToReports();
                },
                icon: 'i-reports',
                isSelected: () => {
                    return this.router.isActive('/reports', false);
                },
            });
        });

        this.campsSecurity.canSellCamps().subscribe((canSellCamps) => {
            if (canSellCamps === false || !this.isDevOrLocalEnvironment()) {
                return;
            }
            this.mainPageComponents.push(<SideMenuLink>{
                name: 'Sell',
                testId: 'side-menu-sell',
                action: () => {
                    this.goToSellCamp();
                },
                icon: 'i-coupon',
                isSelected: () => {
                    return this.router.isActive('/sell', false);
                },
            });
        });

        this.mainPageComponents.push(<SideMenuLink>{
            name: 'Manage images',
            testId: 'side-menu-manage-images',
            action: () => {
                this.goToManageImages();
            },
            icon: 'i-manage-images',
            isSelected: () => {
                return this.router.isActive('/manage-images', false);
            },
        });
    }

    public goToDashboard() {
        this.router.navigate(['/']);
    }

    public goToEnrollment() {
        this.router.navigate(['/purchases']);
    }

    public goToCampsDefinitions() {
        this.router.navigate(['/camps']);
    }

    public goToRoster() {
        this.router.navigate(['/roster']);
    }

    public goToCoupons() {
        this.router.navigate(['/coupons']);
    }

    public goToSellCamp() {
        this.router.navigate(['/sell']);
    }

    public goToReports() {
        this.router.navigate(['/reports']);
    }

    public goToMemberships() {
        this.router.navigate(['/memberships']);
    }

    public goToManageImages() {
        this.router.navigate(['/manage-images']);
    }

    public isDevOrLocalEnvironment(): boolean {
        const env = (window["__RUNTIME_CONFIG__"] as { environment: string })?.environment;
        return env === 'DEV' || env === undefined;
    }

}

class SideMenuLink {
    public name: string;
    public testId: string;
    public action: Function;
    public icon: string;
    public isSelected: Function;
}
